/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'jquery',
	'../../../../widgets/livewidget/nls/StringResources',
	'react-dom',
	'react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types'
], function (_, $, resources, ReactDOM, React, Toolkit, PropTypes) {

	const { FlexLayout, Label } = Toolkit;

	class DrillThroughDefinitionHeader extends React.Component {

		constructor(props) {
			super(props);
		}

		render() {
			return (<FlexLayout className = 'dtEditTitle' direction='column'>
				<Label className = 'dtEditSubTitle' aria-label={this.props.drillDefinitionName} label={this.props.drillDefinitionName} tabIndex={0} />
				<Label className = 'dtEditMainTitle'  aria-label={this.props.mainTitle} label={this.props.mainTitle} tabIndex={0}/>
				<Label className = 'dtEditInfo' aria-label={this.props.subTitle} label={this.props.subTitle} tabIndex={0} />
			</FlexLayout>);
		}
	}

	DrillThroughDefinitionHeader.propTypes = {
		drillDefinitionName: PropTypes.string,
		mainTitle: PropTypes.string,
		subTitle: PropTypes.string
	};
	return DrillThroughDefinitionHeader;
});

